"use client";

import { FadeInView } from "@/components/FadeInView";
import { cn } from "@/lib/utils";

export function RouteLoadingShell({ className }: { className?: string }) {
  return (
    <div
      data-route-slot="loading"
      className={cn("min-w-0 bg-background", className)}
      aria-hidden
    >
      <FadeInView
        triggerOnMount
        className="min-h-[min(50vh,28rem)] w-full"
      >
        <div className="min-h-[inherit] w-full" />
      </FadeInView>
    </div>
  );
}
